export default {
  netMonthlyIncome (incomeState, getters) {
    const grossMonthlyIncome = getters.grossMonthlyIncome
    const grossMonthlyExpenses = getters.grossMonthlyExpenses
    return grossMonthlyIncome - grossMonthlyExpenses
  },

  grossMonthlyIncome (incomeState) {
    const incomeFrequencyOptions = {
      WEEKLY: 4.33,
      'BI-WEEKLY': 2.17,
      'SEMI-MONTHLY': 2,
      MONTHLY: 1
    }

    return incomeState.incomeList.reduce((total, currentIncome) => {
      const frequencyMultiplier = incomeFrequencyOptions[currentIncome.payFrequency] || 0
      const monthlyIncome = (Number.parseInt(currentIncome.incomeAmount) || 0) * frequencyMultiplier
      return total + monthlyIncome
    }, 0)
  },

  grossMonthlyExpenses (incomeState) {
    const rent = incomeState.rent || 0
    const utilities = incomeState.utilities || 0
    const insurance = incomeState.insurance || 0
    const otherExpenses = incomeState.otherExpenses || 0

    const total = rent + utilities + insurance + otherExpenses
    return total || 0
  }
}
